// type
import { type Components, type Theme } from "@mui/material";

export const MuiTextField: Components<Theme>["MuiTextField"] = {
  defaultProps: {
    variant: "outlined",
    autoComplete: "off",
    size: "medium",
    InputLabelProps: {
      shrink: true,
    },
  },
  styleOverrides: {
    root: ({ theme }) => ({
      paddingLeft: 0,
      direction: "ltr",
      caret: theme.palette.primary.main,
      "& label": {
        color: theme.palette.text.secondary,
        fontWeight: 500,
      },
      "& .MuiInputBase-root": {
        color: theme.palette.text.primary,
        borderRadius: 12,
        transition: theme.transitions.create(
          ["border-color", "box-shadow"],
          {
            duration: theme.transitions.duration.short,
          }
        ),
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: theme.palette.divider,
          borderWidth: 1.5,
          transition: theme.transitions.create(["border-color"], {
            duration: theme.transitions.duration.short,
          }),
        },
        "&:hover fieldset": {
          borderColor: theme.palette.grey[400],
        },
        "&.Mui-focused fieldset": {
          borderColor: theme.palette.primary.main,
          borderWidth: 2,
          boxShadow: `0 0 0 3px ${theme.palette.primary.main}12`,
        },
      },
    }),
  },
};
